<template>
<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M85.3554 14.6447L71.2132 28.7868C59.4975 17.0711 40.5025 17.0711 28.7868 28.7868L14.6447 14.6447C34.1709 -4.88155 65.8292 -4.88155 85.3554 14.6447Z" fill="url(#paint0_linear)"/>
<path d="M14.6447 85.3554L28.7868 71.2132C40.5025 82.929 59.4975 82.929 71.2132 71.2132L85.3554 85.3554C65.8291 104.882 34.1709 104.882 14.6447 85.3554Z" fill="url(#paint1_linear)"/>
<path d="M85.3554 85.3554L71.2132 71.2132C82.929 59.4975 82.929 40.5025 71.2132 28.7868L85.3554 14.6447C104.882 34.1709 104.882 65.8291 85.3554 85.3554Z" fill="url(#paint2_linear)"/>
<path d="M14.6447 14.6447L28.7868 28.7868C17.0711 40.5025 17.0711 59.4975 28.7868 71.2132L14.6447 85.3553C-4.88155 65.8291 -4.88155 34.1709 14.6447 14.6447Z" fill="url(#paint3_linear)"/>
<circle cx="78.2843" cy="21.7158" r="10" transform="rotate(45 78.2843 21.7158)" fill="#3B82F6"/>
<defs>
<linearGradient id="paint0_linear" x1="28.5" y1="28.5" x2="71" y2="28.5" gradientUnits="userSpaceOnUse">
<stop stop-color="#3B82F6" stop-opacity="0.81"/>
<stop offset="1" stop-color="#3B82F6"/>
</linearGradient>
<linearGradient id="paint1_linear" x1="71.5" y1="71.5" x2="28.5" y2="71.5" gradientUnits="userSpaceOnUse">
<stop stop-color="#3B82F6" stop-opacity="0.4"/>
<stop offset="1" stop-color="#3B82F6" stop-opacity="0.6"/>
</linearGradient>
<linearGradient id="paint2_linear" x1="71.5" y1="28.5" x2="71.5" y2="71" gradientUnits="userSpaceOnUse">
<stop stop-color="#3B82F6" stop-opacity="0.2"/>
<stop offset="1" stop-color="#3B82F6" stop-opacity="0.4"/>
</linearGradient>
<linearGradient id="paint3_linear" x1="28.5" y1="71.5" x2="28" y2="29" gradientUnits="userSpaceOnUse">
<stop stop-color="#3B82F6" stop-opacity="0.6"/>
<stop offset="1" stop-color="#3B82F6" stop-opacity="0.8"/>
</linearGradient>
</defs>
</svg>
</template>

<script>
export default {
  name: 'LogoRadar'
}
</script>